import ControlExchangeLogo from "@/components/brand/ControlExchangeLogo";
import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef } from "react";

export const BrandLoadingIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"span">) => (
  <span
    aria-hidden={props["aria-label"] ? undefined : "true"}
    className={cn("inline-grid h-4 w-6 shrink-0 place-items-center", className, "animate-none")}
    {...props}
  >
    <ControlExchangeLogo
      animated
      decorative
      markOnly
      className="h-full w-full"
      markClassName="h-full w-full"
    />
  </span>
);

export const LoadingSpinner = ({ 
  size = "default", 
  text = "Loading..." 
}: { 
  size?: "sm" | "default" | "lg";
  text?: string;
}) => {
  const sizeClasses = {
    sm: {
      halo: "h-7 w-7",
      mark: "h-5",
    },
    default: {
      halo: "h-12 w-12",
      mark: "h-9",
    },
    lg: {
      halo: "h-20 w-20",
      mark: "h-14",
    },
  };

  return (
    <div
      className="flex items-center justify-center p-8"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="relative grid place-items-center">
          <span
            aria-hidden="true"
            className={cn(
              "control-exchange-loader-halo absolute rounded-full bg-primary/10 blur-sm",
              sizeClasses[size].halo,
            )}
          />
          <ControlExchangeLogo
            animated
            markOnly
            className="control-exchange-loader-mark relative"
            markClassName={sizeClasses[size].mark}
          />
        </div>
        <p className="text-sm font-medium tracking-[-0.01em] text-muted-foreground">{text}</p>
      </div>
    </div>
  );
};

export const PageLoadingSpinner = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <LoadingSpinner size="lg" text="Loading page..." />
    </div>
  );
};
